import {combineReducers} from "redux";
import {reducer as editorReducer } from '../Components/CardBuilder';
import {reducer as notificationsReducer } from '../Components/SnackBar';
import {reducers as businessCardReducers } from '../Components/BusinessCard';
import {reducer as LoadingIndicatorReducer } from '../Components/LoadingIndicator';
// console.log("reducers")
// console.log(businessCardReducers)

const { businessCardReducer } = businessCardReducers;

// const actionTypes = {
//   isLoadingActionType:[businessCardActionTypes.fetchCard],
//   successActionType:[businessCardActionTypes.fetchCardSuccess],
//   errorActionType:[businessCardActionTypes.fetchCardError]
// };

// const businessCardRedcuer = combineReducers({
//   clientInfo: clientInfoReducer,
//   settings: settingsReducer,
//   cardActions: actionsReducer,
//   images: imagesReducer
// });

const appReducer = combineReducers({
  snackbar: notificationsReducer,
  LoadingIndicator: LoadingIndicatorReducer
});

const rootReducer = combineReducers({
  businessCards: businessCardReducer,
  app: appReducer,
  editor: editorReducer
});


export default rootReducer;